package com.eladfinish.bible.contest.screens.main.api

import com.eladfinish.bible.contest.network.DefaultApiResult
import com.eladfinish.bible.contest.network.apiTextResult
import com.eladfinish.bible.contest.network.spreadsheet.getGoogleDocsUrlForDownload
import io.ktor.client.HttpClient
import io.ktor.client.request.get

interface MainApi {
    suspend fun getRemoteText(): DefaultApiResult<String>
}

class MainApiImpl(
    private val client: HttpClient,
) : MainApi {

    companion object {
        const val remoteFile = "https://drive.google.com/open?id=1vJedY2ecGiSJr1-Ft5WB3bv7frl6F4vJ"
    }

    override suspend fun getRemoteText(): DefaultApiResult<String> = apiTextResult {
        val url = getGoogleDocsUrlForDownload(remoteFile)
        client.get(url)
    }

}
